var _rect, _rect2, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 19.5,
    height: 19.5,
    rx: 9.75,
    fill: "url(#paint0_linear_6637_43516)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 19.5,
    height: 19.5,
    rx: 9.75,
    stroke: "#3A7F29",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8486 4.95127C15.141 4.95127 13.7525 3.63192 13.7525 2H6.27069C6.27069 3.63192 4.88225 4.95127 3.16807 4.95127C3.16478 4.95127 3.16478 4.95127 3.1582 4.95127C3.32271 9.824 4.28673 14.7987 10.0116 17.7895C15.7365 14.7987 16.7005 9.824 16.865 4.95127H16.8486ZM10.0116 16.1082C5.81994 13.7163 4.88225 9.96218 4.66181 6.13902C5.98116 5.81329 7.02417 4.81309 7.36303 3.54308H12.6602C13.0024 4.81638 14.0421 5.81658 15.3647 6.14231C15.1443 9.96218 14.2 13.7163 10.0116 16.1082Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94162 7.19192C8.94162 6.60298 9.42198 6.12262 10.0109 6.12262C10.5999 6.12262 11.0802 6.60298 11.0802 7.19192V7.54396H11.5902V7.19192C11.5902 6.32002 10.8828 5.61264 10.0109 5.61264C9.13902 5.61264 8.43164 6.32002 8.43164 7.19192V7.54396H8.94162V7.19192Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8443 8.03748H8.17907C7.90599 8.03748 7.68555 8.25792 7.68555 8.531V11.4724C7.68555 11.7455 7.90599 11.9659 8.17907 11.9659H11.8443C12.1174 11.9659 12.3378 11.7455 12.3378 11.4724V8.531C12.3378 8.25792 12.1174 8.03748 11.8443 8.03748ZM10.4888 10.9591H9.53791L9.65964 10.1037C9.51817 9.99841 9.42275 9.82732 9.42275 9.6332C9.42275 9.30744 9.68596 9.04426 10.015 9.04426C10.3407 9.04426 10.6006 9.30748 10.6006 9.6332C10.6006 9.82732 10.5085 9.99841 10.3637 10.107L10.4888 10.9591Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6637_43516",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AC069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CA34B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureIcon);
export default __webpack_public_path__ + "static/media/secure-icon.f9ad8ea9eaba79ae3960164648f93fe6.svg";
export { ForwardRef as ReactComponent };